import moment, {Moment} from 'moment';
import {InterfaceMediaItem} from "../../interface/press-center/interface.media";
import {webApi} from "../../common/consts";
// import {MediaPage} from "./media.page";
// import {MediaStore} from "../../store/media.store";

export class MediaBody {
    private centerMediaImportantContent: HTMLElement | null;
    private pressCenterMediaContent: HTMLElement | null;
    private pressCenterMediaImportantContent: HTMLElement | null;

    constructor(
        private container: HTMLElement,
        private mediaItems: InterfaceMediaItem[],
        private totalCount: number,
        private loader: HTMLElement | null,

    ) {

        this.centerMediaImportantContent
            = this.container.querySelector('[press-center-media-important-content]');
        this.pressCenterMediaContent = this.container.querySelector('[data-press-center-media-content]');
        this.pressCenterMediaImportantContent
            = this.container.querySelector('[data-press-center-media-important-content]');
    }

    public initialize(): void {
        let mediaContent = '';
        this.mediaItems.forEach(
            (
                mediaItem: InterfaceMediaItem
            ) => {
                mediaContent += this.getTemplate(mediaItem);
            });


        if (this.pressCenterMediaContent) {
            this.pressCenterMediaContent.innerHTML = mediaContent;
        }
    }

    private getTemplate(mediaItem: InterfaceMediaItem): string {
        const titleWithoutSpaces = mediaItem.Header.split(' ').join('-');

        return `
            
            <a href="${mediaItem.Link}" class="press-center__article" target="_blank">
                  <div class="press-center__article-kind-background">
                    <img src="${webApi}${mediaItem.ImgUrl}" alt="img">
                  </div>
                  <h5>${mediaItem.Header}</h5>
            </a>
        `
    }
}
